var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002237"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 404",
    x: 9,
    y: 8,
    width: 13,
    height: 13,
    fill: "#23233F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 403"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_185_772",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4
  })), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    stroke: "#23233F",
    strokeWidth: 10,
    mask: "url(#path-2-inside-1_185_772)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.3734bda594cbde1069d837bfeb9c0c1f.svg";
export { ForwardRef as ReactComponent };